export function calculateAbcdDermatoscopie(input: {
    asymmetrie: number | null;
    border: number | null;
    color: number | null;
    differentialStructures: number | null;
}) {
    if (
        input.asymmetrie === null ||
        input.asymmetrie < 0 ||
        input.asymmetrie > 2 ||
        input.border === null ||
        input.border < 0 ||
        input.border > 8 ||
        input.color === null ||
        input.color < 0 ||
        input.color > 6 ||
        input.differentialStructures === null ||
        input.differentialStructures < 0 ||
        input.differentialStructures > 5
    ) {
        return null;
    }

    return 1.3 * input.asymmetrie + 0.1 * input.border + 0.5 * input.color + 0.5 * input.differentialStructures;
}

export function getAbcdDermatoscopiescoreByTotal(total: number) {
    let result = null;

    if (total < 4.75) {
        result = 'Een score lager dan 4.75 past bij een benigne moedervlek';
    } else if (4.75 <= total && total <= 5.45) {
        result = 'Een score tussen 4.75-5.45 past bij een dysplastische naevus';
    } else {
        result = 'Een score boven 5.45 is suggestief voor een melanoom';
    }

    return result;
}
